import * as React from "react";

export const getHighlightedText = (text: string, highlight: string): React.ReactElement => {
	// Split text on highlight term, include term itself into parts, ignore case
	const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
	return <span className="">{parts.map(part => part.toLowerCase() === highlight.toLowerCase() ? <span className="autosuggest__keyword">{part}</span> : part)}</span>;
}
